export default {
  required: 'Pflichtfeld',
  incompleteFieldList: 'Zuerst ausfüllen: {fields}',
  unboundIssueListHeader: 'Vor dem Speichern beheben',
  discardHeader: 'Ungespeicherte Änderungen verwerfen?',
  discardMessage: 'Dadurch werden alle Änderungen seit dem letzten Speichern gelöscht.',
};
